import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, PawPrint } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { id: NAV.home, label: "Home", href: "#home" },
  { id: NAV.about, label: "Our Promise", href: "#about" },
  { id: NAV.puppies, label: "Golden Retrievers", href: "#puppies" },
  { id: NAV.videos, label: "Videos", href: "#videos" },
  { id: NAV.reviews, label: "Reviews", href: "#reviews" },
  { id: "nav-link-careers", label: "Careers", href: "#careers" },
];

export const Header = ({ onEnquire }) => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 w-full z-40 bg-[#F9F8F6]/85 backdrop-blur-xl border-b border-[#DCD7CE]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#home" data-testid={NAV.logo} className="flex items-center gap-2 group">
          <PawPrint className="w-6 h-6 text-[#D97736] transition-transform group-hover:rotate-12" />
          <span className="font-display text-xl md:text-2xl font-bold tracking-tight text-[#0F2520]">
            Raijada <span className="text-[#D97736]">Kennel</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              data-testid={l.id}
              href={l.href}
              className="text-sm font-medium uppercase tracking-widest text-[#0F2520]/70 hover:text-[#D97736] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid={NAV.enquireBtn}
            onClick={onEnquire}
            className="rounded-full bg-[#0F2520] text-[#F9F8F6] px-6 py-2.5 text-sm font-semibold tracking-wide hover:bg-[#D97736] transition-colors duration-300 hover:scale-105 active:scale-95"
          >
            Enquire Now
          </button>
        </div>

        <button
          data-testid={NAV.mobileMenuToggle}
          className="md:hidden text-[#0F2520]"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="md:hidden bg-[#F9F8F6] border-t border-[#DCD7CE] px-6 py-6 flex flex-col gap-5"
        >
          {links.map((l) => (
            <a key={l.id} href={l.href} onClick={() => setOpen(false)} className="text-base font-medium text-[#0F2520]">
              {l.label}
            </a>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              onEnquire();
            }}
            className="rounded-full bg-[#D97736] text-white px-6 py-3 text-sm font-semibold"
          >
            Enquire Now
          </button>
        </motion.div>
      )}
    </header>
  );
};
